import { useCallback, useEffect, useState } from "react";
import DataTable from "../datatable/DataTable";
import "./contact.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const contactListingEndPoint = ApiEndpoints.contact.contactList;
const tableHeader = ["Name", "Email Address", "Country Name", "PhoneNumber", "Service", "Message", "Source", "Date", "IP Address"];
const tbody = ["name", "email", "country", "phoneNumber", "subject", "message", "source_url", "createdAt","ip_address"];

export default function ContactListingAdmin() {
  const [data, setData] = useState([]);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" };
    return new Date(dateString).toLocaleDateString("en-GB", options).replace(',', ''); // Output like 24 Sep 2024, 06:26:28
  };

  const dataFetch = useCallback(
    async () => {
      try {
        const response = await ApiRequest("GET", contactListingEndPoint);
        const result = response.contacts.map(contact => ({
          ...contact,
          createdAt
            : formatDate(contact.updatedAt), // Format updatedAt before setting the data
        }));
        console.log(response)
        setData(result);
      } catch (error) {
        console.log(error);
      }
    }, [contactListingEndPoint]);

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);

  return (
    <>
      <div className="header-add-category">
        <h5>Leads Data</h5>
      </div>
      <div className="contactadmin-section">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
      </div>
    </>
  );
}
